import { useState } from "react";
import { HStack, TabList, TabPanel, Tabs } from "@chakra-ui/react";
import { Tab, TabPanels } from "components";
import { AddAccount, GetAccounts } from "ui";

// interface IProps {
//   tabChange: (index: number) => void;
// }
const CicoFiat = () => {
  const [tabIndex, changeTab] = useState(0);
  const handleTabChange = (index: number) => {
    changeTab(index);
  };

  return (
    <>
      <Tabs variant="ghost" index={tabIndex} onChange={handleTabChange}>
        <HStack w="100%">
          <TabList w="100%" flex={{ base: "6", "2sm": "4" }} borderRadius="8px">
            <Tab noShadow fontSize="sm">
              Add Account
            </Tab>
            <Tab noShadow fontSize="sm">
              All Accounts
            </Tab>
          </TabList>
        </HStack>

        <TabPanels index={tabIndex} onChangeIndex={handleTabChange} mt="24px">
          <TabPanel padding={{ base: "1rem 8px", "2sm": "1rem" }}>
            <AddAccount handleTabChange={handleTabChange} />
          </TabPanel>

          <TabPanel padding={{ base: "1rem 8px", "2sm": "1rem" }}>
            <GetAccounts />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </>
  );
};

export default CicoFiat;
